import { get } from 'lodash';

const STORAGE_KEYS = {
  TOKEN: 'token',
  SERVICES: 'services',
  REMEMBER_ME: 'rememberMe',
  USER_DETAIL: 'persist:root',
};

export function setStorageRememberMe(isChecked) {
  window.localStorage.setItem(STORAGE_KEYS.REMEMBER_ME, isChecked);
}

export function getStorageRememberMe() {
  const rememberMe = localStorage.getItem(STORAGE_KEYS.REMEMBER_ME);
  return rememberMe ? JSON.parse(rememberMe) : false;
}

export function setSessionStorageToken(token) {
  window.sessionStorage.setItem(STORAGE_KEYS.TOKEN, JSON.stringify(token));
}

export function getSessionStorageToken() {
  const token = window.sessionStorage.getItem(STORAGE_KEYS.TOKEN);
  return token ? JSON.parse(token) : null;
}

export function setLocalStorageToken(token) {
  window.localStorage.setItem(STORAGE_KEYS.TOKEN, JSON.stringify(token));
}

export function getLocalStorageToken() {
  const token = window.localStorage.getItem(STORAGE_KEYS.TOKEN);
  return token ? JSON.parse(token) : null;
}

export function setToken(token) {
  const rememberMe = getStorageRememberMe();
  if (rememberMe) {
    setLocalStorageToken(token);
  } else {
    setSessionStorageToken(token);
  }
}

export function getToken() {
  if (getSessionStorageToken()) {
    return getSessionStorageToken();
  }
  if (getLocalStorageToken()) {
    return getLocalStorageToken();
  }
  return null;
}

export function setStorageServices(services) {
  window.localStorage.setItem(STORAGE_KEYS.SERVICES, JSON.stringify(services));
}

export function getStorageServices() {
  const services = window.localStorage.getItem(STORAGE_KEYS.SERVICES);
  return services ? JSON.parse(services) : {};
}

export function getStorageUser() {
  let detail = localStorage.getItem(STORAGE_KEYS.USER_DETAIL);
  detail = detail ? JSON.parse(detail) : null;
  const user = detail ? get(detail, 'session') : null;
  return user ? get(JSON.parse(user), 'user') : null;
}

export function removeLoggedInDetail() {
  window.localStorage.removeItem(STORAGE_KEYS.TOKEN);
  window.sessionStorage.removeItem(STORAGE_KEYS.TOKEN);
  window.localStorage.removeItem(STORAGE_KEYS.SERVICES);
}
